module.exports = __webpack_public_path__ + "static/media/other.8f0e8bb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/other.png
// module id = 236
// module chunks = 0